import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-119756b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "full-screen-img"
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "main-image",
      style: _normalizeStyle({width:_ctx.props.width+'px'})
    }, [
      (_ctx.props.fileType===0)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            ref: "displayImage",
            style: _normalizeStyle({'maxWidth':_ctx.props.width+'px','maxHeight':_ctx.props.height+'px'}),
            src: _ctx.props.file?_ctx.props.file: _ctx.props.url,
            alt: ""
          }, null, 12, _hoisted_1))
        : (_ctx.props.fileType===2)
          ? (_openBlock(), _createElementBlock("video", {
              key: 1,
              controls: "",
              ref: "displayImage",
              style: _normalizeStyle({'maxWidth':_ctx.props.width+'px','maxHeight':_ctx.props.height+'px'}),
              src: _ctx.props.file?_ctx.props.file: _ctx.props.url,
              alt: ""
            }, null, 12, _hoisted_2))
          : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "cover",
        style: _normalizeStyle({width:_ctx.props.width+'px',height:_ctx.props.height+'px'})
      }, [
        _createElementVNode("div", {
          class: "img-command",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewimg(true)))
        }, "查询"),
        (_ctx.showDel)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "img-command",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteImg && _ctx.deleteImg(...args)))
            }, "删除"))
          : _createCommentVNode("", true)
      ], 4)
    ], 4),
    (_ctx.isFull)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.viewimg(false)))
          }, [
            _createVNode(_component_svg_icon, { icon: "error" })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: _ctx.fulldisplayImageSrc,
              alt: ""
            }, null, 8, _hoisted_4)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}